import React from 'react';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';

export const AuthContext = React.createContext(null);

export const ProtectedRoute = ({ children }) => {
    const { token } = useAuth();
    const location = useLocation();

    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [token, setToken] = React.useState(window.localStorage.getItem("token"));
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");

    const handleLogin = async () => {
        const url = "authentication";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: "POST",
            body: "email=" + email + "&password=" + password,
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                }
                return response.text();
            })
            .then((data) => {
                if (data !== "") {
                    setToken(data);
                    window.localStorage.setItem("token", data);

                    //const origin = location.state?.from?.pathname || '/';
                    navigate('/domotica');
                }
                else {
                    setToken(null);
                }
            })
            .catch(err => {
                setToken(null);
                console.log('erro');
                console.log(err);

                navigate('/');
            });
    };

    const handleLogout = async () => {
        setToken(null);
        const url = "authentication/logout";
        const options = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            method: "GET"
        };

        await fetch(url, options)
            .then((response) => {
                if (response.status !== 200) {
                    console.log('fetch returned not ok' + response.status);
                    return '';
                }
                return response.text();
            })
            .then((data) => {
                window.localStorage.removeItem("token");
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleEmail = (event) => {
        setEmail(event.target.value);
    };

    const handlePassword = (event) => {
        setPassword(event.target.value);
    };


    const authObj = {
        token,
        onLogin: handleLogin,
        onLogout: handleLogout,
        onEmailChange: handleEmail,
        onPasswordChange: handlePassword,
    };

    /*
    registerSuccessfulLogin(username, password) {
        console.log("Login Successful");
        sessionStorage.setItem("authenticatedUser", username);
        console.log(sessionStorage.getItem("authenticatedUser"));
    }

    isUserLoggedIn() {
        let user = sessionStorage.getItem("authenticatedUser");

        if (user === null) {
            return false;
        } else {
            return true;
        }
    }

    logout() {
        sessionStorage.removeItem("authenticatedUser");
    }

    getLoggedInUserName() {
        let user = sessionStorage.getItem("authenticatedUser");
        if (user === null) return "";
        return user;
    }
    */

    return (
        <AuthContext.Provider value={authObj}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    return React.useContext(AuthContext);
};